"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ALERTS_ESCALATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ALERTS_ESCALATION;
  }
});
Object.defineProperty(exports, "ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ANALYTICS;
  }
});
Object.defineProperty(exports, "AUTOMATED_ROUTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUTOMATED_ROUTING;
  }
});
Object.defineProperty(exports, "AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUTOMATION;
  }
});
Object.defineProperty(exports, "CUSTOMER_PORTAL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMER_PORTAL;
  }
});
Object.defineProperty(exports, "CUSTOMER_SATISFACTION_SURVEY", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMER_SATISFACTION_SURVEY;
  }
});
Object.defineProperty(exports, "CUSTOMIZABLE_BRANDING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMIZABLE_BRANDING;
  }
});
Object.defineProperty(exports, "DASHBOARDS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DASHBOARDS;
  }
});
Object.defineProperty(exports, "DOCUMENT_STORAGE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DOCUMENT_STORAGE;
  }
});
Object.defineProperty(exports, "EMAIL_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EMAIL_INTEGRATION;
  }
});
Object.defineProperty(exports, "EMAIL_TO_CASE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EMAIL_TO_CASE;
  }
});
Object.defineProperty(exports, "INTERACTION_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INTERACTION_TRACKING;
  }
});
Object.defineProperty(exports, "IT_ASSET_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.IT_ASSET_MANAGEMENT;
  }
});
Object.defineProperty(exports, "KNOWLEDGE_BASE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.KNOWLEDGE_BASE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "MAKE_RECEIVE_RECORD_CALLS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MAKE_RECEIVE_RECORD_CALLS;
  }
});
Object.defineProperty(exports, "MULTI_CHANNEL_COMMUNICATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MULTI_CHANNEL_COMMUNICATION;
  }
});
Object.defineProperty(exports, "NETWORK_MONITORING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.NETWORK_MONITORING;
  }
});
Object.defineProperty(exports, "POINTS_OF_CONTACT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.POINTS_OF_CONTACT;
  }
});
Object.defineProperty(exports, "REAL_TIME_CHAT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REAL_TIME_CHAT;
  }
});
Object.defineProperty(exports, "RESPONSE_AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.RESPONSE_AUTOMATION;
  }
});
Object.defineProperty(exports, "SELF_SERVICE_PORTAL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SELF_SERVICE_PORTAL;
  }
});
Object.defineProperty(exports, "SERVICE_LEVEL_AGREEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SERVICE_LEVEL_AGREEMENT;
  }
});
Object.defineProperty(exports, "SOCIAL_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_INTEGRATION;
  }
});
Object.defineProperty(exports, "TICKET_COLLABORATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TICKET_COLLABORATION;
  }
});
Object.defineProperty(exports, "TICKET_ISSUE_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TICKET_ISSUE_TRACKING;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/HelpDesk.js
// module id = 571
// module chunks = 209 210 211 212 213